/* =========================================================================
   ClueVine — word lists
   Two pools feed the dictionary:
   - ANSWER_WORDS  — the hand-curated common list. Daily secrets, Tangle targets,
     and Forge seeds are drawn from here so puzzles stay familiar and fair.
   - VALID_WORDS   — the large bundled "common words" corpus (32k) UNION the
     curated list, so the game accepts a wide range of guesses and Forge/Tangle
     have rich solution sets. The union guarantees every answer is also a valid
     guess.

   The big corpus is bundled at build time via Vite's `?raw` import. To grow or
   swap it, replace src/data/common-words.txt — nothing else changes.
   ========================================================================= */

import commonRaw from './common-words.txt?raw';
import { STARTER_WORDS } from './words';

const COMMON: string[] = commonRaw
  .split(/\r?\n/)
  .map((w) => w.trim())
  .filter(Boolean);

/** Curated, answer-quality words (the secret-word / target pool). */
export const ANSWER_WORDS: readonly string[] = STARTER_WORDS;

/** Everything the game will accept as a valid word (corpus ∪ curated). */
export const VALID_WORDS: readonly string[] = [...COMMON, ...STARTER_WORDS];
